import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { systemAPI } from '../../apis';

const useStyles = makeStyles((theme) => ({
  transitionContainer: {
    position: 'relative',
    width: '100%',
  },
  transitionItem: {
    opacity: 0,
    position: 'absolute',
    transition: 'opacity 1s',
    height: 'inherit',
    width: '100%',
    cursor: 'default',
    '& a': {
      cursor: 'default'
    },
    zIndex:1
  },
  active: {
    transition: 'opacity 6s',
    opacity: 1,
    cursor: 'text',
    '& a': {
      cursor: 'pointer'
    },
    zIndex:999
  },
}));

const SystemDisplayMessage = ({
  displayKey,
  hospitalId,
  wardId,
  language = 'en-us',
  defaultLanguage = 'en-us',
  transitionDuration = 7,
  interval = 600,
}) => {
  const classes = useStyles();
  const [content, setContent] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedLanguageContent, setSelectedLanguageContent] = useState([]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await systemAPI.getDisplayMessage(
          { key: displayKey, hospitalId, wardId },
          { isHideLoading: true }
        );
        const data = response?.result ?? [];
        const newContent = data.reduce((acc, item) => {
          const lng = item?.language?.toLowerCase() ?? '';
          acc[lng] = acc[lng] || [];
          acc[lng].push(item);
          return acc;
        }, {});
        setContent(newContent);
        setCurrentIndex(0);
      } catch (error) {
        setContent({});
      }
    };

    fetchData();

    const intervalId = setInterval(fetchData, interval * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [displayKey, hospitalId, wardId, interval]);

  useEffect(() => {
    if (selectedLanguageContent.length > 1) {
      const timeoutId = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % selectedLanguageContent.length);
      }, transitionDuration * 1000);

      return () => {
        clearInterval(timeoutId);
      };
    }
  }, [selectedLanguageContent, transitionDuration]);

  useEffect(() => {
    let checkingContent =
      (content[language]?.length ?? 0) >= (content[defaultLanguage]?.length ?? 0)
        ? content[language]
        : content[defaultLanguage];
    checkingContent = (checkingContent?.length ?? 0) > 0 ? checkingContent : [];
    setSelectedLanguageContent(checkingContent);
  }, [content, language, defaultLanguage]);

  return selectedLanguageContent?.length > 0 > 0 ? (
    <div className={classes.transitionContainer}>
      {selectedLanguageContent?.length > 0 &&
        selectedLanguageContent.map((item, index) => (
          <div
            key={item.displayValue}
            className={`${classes.transitionItem} ${index === currentIndex ? classes.active : ''}`}
            dangerouslySetInnerHTML={{ __html: item.displayValue }}
          />
        ))}
    </div>
  ) : null;
};

export default SystemDisplayMessage;
